import { createShortUid, logError } from '@amazon/vinyl-util'
import { ctx } from '../env/playbackContext'
import type { InterludeFields } from '../gql/interludeFieldsFrag'
import type { PlaylistEntry } from './PlaylistController'

const { target } = ctx('interludeToPlaylistEntry')

/** A queue interlude, played off its own url and titled by its name alone. */
export function interludeToPlaylistEntry(interlude: InterludeFields): PlaylistEntry | null {
    const audioUrl = interlude.playbackInformation?.audioUrl
    if (!audioUrl) {
        logError(target, 'interlude missing audioUrl', interlude.id)
        return null
    }
    return {
        id: interlude.id ?? createShortUid(),
        entity: interlude,
        title: interlude.name ?? '',
        albumTitle: '',
        artistName: '',
        duration: 0,
        image: interlude.image,
        trackLoadOptions: { type: 'src', uri: audioUrl },
    }
}
